module.exports = __webpack_public_path__ + "img/Vector76.fc930bac.svg";